<template>
  <div class="donate-button">
    <v-btn
      :variant="variant"
      :size="size"
      :color="color"
      @click="handleClick"
    >
      {{ text }}
    </v-btn>
    <DonateModal
      v-model="showModal"
      :venmo-url="venmoUrl"
      :venmo-qr-url="venmoQrUrl"
    />
  </div>
</template>

<script>
import DonateModal from "./DonateModal.vue";

export const VENMO_URL = "https://venmo.com/u/BHMLF?txn=pay&note=Donation";
export const VENMO_QR_URL =
  "https://venmo.com/api/qrcode?output=svg&type=bizprofile&payload=4027359300683293909&v=2";

export default {
  name: "DonateButton",
  components: {
    DonateModal,
  },
  props: {
    variant: {
      type: String,
      default: "flat",
    },
    size: {
      type: String,
      default: "default",
    },
    color: {
      type: String,
      default: "primary",
    },
    text: {
      type: String,
      default: "Donate",
    },
    venmoUrl: {
      type: String,
      default: VENMO_URL,
    },
    venmoQrUrl: {
      type: String,
      default: VENMO_QR_URL,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    handleClick() {
      if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        window.open(this.venmoUrl, "_blank", "noopener,noreferrer");
        return;
      }
      this.showModal = true;
    },
  },
};
</script>

<style scoped>
.donate-button {
  display: inline-flex;
  align-items: center;
}
</style>
